export const PolicyPayload = 'PolicyPayload';
export const PolicyFrequency = 'PolicyFrequency';
export const PromotionPayload = 'PromotionPayload';
export const NominationPayload = 'NominationPayload';
export const UtmPayload = 'UtmPayload';
export const AgentCodePayload = 'AgentCodePayload';
export const PartnerPayload = 'PartnerPayload';
export const PromoCodeExpiredDays = 14;
export const SmartlookPayload = 'SmartlookPayload';
export const MultiQuotePayload = 'MultiQuotePayload';
export const DocumentUploadFlag = 'DocumentUploadFlag';
export const DocumentUploadedPayload = 'DocumentUploadedPayload';
export const PromoCodePayload = 'PromoCodePayload';
export const PromoCodeSummaryPayload = 'PromoCodeSummaryPayload';
export const OriginalPremiumPlanPayload = 'OriginalPremiumPlanPayload';
export const DeductiblePayload = 'DeductiblePayload';
export const UnderwriteMeStaticAnswersPayload = 'UnderwriteMeStaticAnswersPayload';
export const UnderwriteMeValidationPayload = 'UnderwriteMeValidationPayload';
export const ApplicationPolicyPayload = 'ApplicationPolicyPayload';
export const DonationPayload = 'DonationPayload';
export const ToastNotificationPayload = 'ToastNotification';
export const PolicyRefNoPayload = 'PolicyRefNoPayload';
export const EPFCampaignCodePayload = 'EPFCampaignCodePayload';
export const EmploymentStatus = 'EmploymentStatus';
export const InitialUwmeQuestion = 'InitialUwmeQuestion';
export const EnquiryRemarks = 'EnquiryRemarks';
export const EnquiryRemarksExceed5K = 'exceeded RM5K ACE';

export const PaymentMode = Object.freeze({
  telemarketing: 'tm'
});

export const PaymentMethod = Object.freeze({
  eWallet: 'EWALLET',
  fpx: 'FPX',
  creditCard: 'CREDITCARD',
  hsbcCreditCard: 'HSBCCREDITCARD'
});

export const PaymentFreq = {
  monthly: 'MONTHLY',
  annually: 'ANNUALLY'
};

export const PaymentStatus = {
  success: 'SUCCESS',
  failed: 'FAILED'
};

export const FamilyStructure = Object.freeze({
  single: 'S',
  couple: 'C',
  family: 'F',
  divorced: 'D'
});

export const MemberType = {
  owner: 'owner',
  spouse: 'spouse',
  child: 'child'
};

export const Relationship = {
  owner: 'SE',
  spouse: 'SP',
  child: 'CH',
  parent: 'PA',
  others: 'OT'
};

export const AddressType = {
  residential: 'R',
  mailing: 'C'
};

export const IDType = {
  nric: 'ID'
};

export const Gender = {
  male: 'M',
  female: 'F'
};

export const TelType = {
  mobile: 'M'
};

export const ProductCode = Object.freeze({
  termLife: 'termLife',
  termCancer: 'termCancer',
  medSecure: 'medSecure',
  b40: 'b40',
  b40Sedania: 'b40Sedania',
  b40Senang: 'b40Senang',
  b40PTV: 'b40PTV',
  disability: 'specialCare',
  big3product: 'big3',
  spinTheWheel: 'spinTheWheel',
  epfCI: 'epfci',
  epfProtect: 'epfprotect',
  specialMed: 'specialMed',
  medicalProduct: 'medicalProduct',
  mcPlus: 'mcplus',
  epp: 'epp',
  epl: 'epl'
});

export const AdditionalCoverage = Object.freeze({
  accidentalMedical: 'accidMedR',
  heartNeurDisorder: 'heartNeurR'
});

export const PlanCode = Object.freeze({
  basic: 'BAS',
  premium: 'PRE',
  best: 'BES',
  b40plan1: 'B40Plan1',
  b40plan2: 'B40Plan2',
  b40plan3: 'B40Plan3',
  b40plan4: 'B40Plan4',
  big3basic: 'Big3BasicPlan',
  big3rider: 'BAS',
  smdPlan1: 'SmdPlan1',
  smdPlan2: 'SmdPlan2',
  smdRider: 'guardianR',
  mcPlus1: 'McplusC1',
  mcPlus2: 'McplusC2',
  mcPlus3: 'McplusC3',
  mcPlus4: 'McplusC4',
  mcPlus5: 'McplusC5',
  mcPlus6: 'McplusC6'
});

export const PlanOptions = {
  McplusC1: 'Medical Plus',
  McplusC3: 'Medical Plus',
  McplusC5: 'Medical Plus',
  McplusC2: 'Medical Pro',
  McplusC4: 'Medical Pro',
  McplusC6: 'Medical Pro'
};

export const Deductible = {
  McplusC1: 0,
  McplusC2: 0,
  McplusC3: 1000,
  McplusC4: 1000,
  McplusC5: 2000,
  McplusC6: 2000
};

export const ApiResult = Object.freeze({
  success: 'SUCCESS',
  fail: 'FAILED'
});

export const UnderwriteMeResult = {
  standard: 'STANDARD',
  nonStandard: 'NON_STANDARD',
  evidenceRequired: 'EVIDENCE_REQUIRED',
  evidenceRefer: 'REFER',
  error: 'ERROR',
  decline: 'DECLINE'
};

export const EventType = {
  loading: 'loading',
  responseError: 'responseError',
  connectionDown: 'connectionDown',
  C2LDown: 'C2LDown'
};

export const QuestionType = {
  date: 'DATE',
  futureDate: 'FUTURE_DATE',
  pastDate: 'PAST_DATE',
  integer: 'INTEGER',
  number: 'NUMBER',
  optionBacked: 'OPTION_BACKED',
  optionGroup: 'OPTION_GROUP',
  optionList: 'OPTION_LIST',
  string: 'STRING'
};

export const QuestionCategories = {
  Specify_Cancer: 'Cancer',
  Specify_Cancer3Male: 'Cancer',
  Specify_Cancer3Female: 'Cancer',
  Specify_HeartOthers: 'Circulatory',
  SpecifyOnline_CISMale: ['Cancer', 'Growths_abscesses_cysts', 'Unrecognised'],
  SpecifyOnline_CISFemale: ['Cancer', 'Growths_abscesses_cysts', 'Unrecognised'],
  SpecifyOnline_TumourMale: ['Cancer', 'Growths_abscesses_cysts', 'Unrecognised'],
  SpecifyOnline_TumourFemale: ['Cancer', 'Growths_abscesses_cysts', 'Unrecognised'],
  SpecifyOnline_TestMarkerMale: [
    'Tests_and_investigations',
    'Cancer',
    'Urological_disorders',
    'Unrecognised'
  ],
  SpecifyOnline_TestMarkerFemale: [
    'Tests_and_investigations',
    'Cancer',
    'Gynaecological_disorders',
    'Growths_abscesses_cysts',
    'Unrecognised'
  ],
  SpecifyOnline_CIS: ['Cancer', 'Growths_abscesses_cysts', 'Unrecognised'],
  SpecifyOnline_Tumour: ['Cancer', 'Growths_abscesses_cysts', 'Unrecognised'],
  SpecifyOnline_TestDRE: ['Urological_disorders', 'Cancer', 'Unrecognised'],
  SpecifyOnline_TestFemale: [
    'Gynaecological_disorders',
    'Growths_abscesses_cysts',
    'Unrecognised',
    'Cancer'
  ]
};

export const CampaignName = Object.freeze({
  Nissan: 'nissan',
  Fastjobs: 'fastjobs'
});

export const PromoCodeResult = Object.freeze({
  invalid: 'Invalid', // The code may not exist
  valid: 'Valid', // The code is valid
  expired: 'Expired', // The code has expired
  used: 'Used', // The code has been used up
  invalidProduct: 'InvalidProduct' // Invaid promote code for product
});

export const UtmSource = Object.freeze({
  telemarketing: 'telemarketing',
  AIB: 'AIB'
});

export const urlPath = Object.freeze({
  termLife: 'protect-direct',
  termCancer: 'care-direct',
  medSecure: 'medsecure-direct',
  specialCare: 'special-care',
  big3: 'big-3-critical-illness',
  b40: 'kasih',
  b40Sedania: 'kasih/sedania',
  b40Senang: 'kasih/senang/petronas',
  b40PTV: 'kasih/ptv',
  epfci: 'epf/ci',
  epfprotect: 'epf/protect',
  specialMed: 'SpecialMed',
  mcPlus: 'medical-care',
  epp: 'epp',
  epl: 'epl'
});

export const HSBC_BINS = [
  '438675',
  '512089',
  '436480',
  '453966',
  '492159',
  '540041',
  '541288',
  '549854',
  '543293',
  '461772',
  '462286',
  '436481',
  '476670',
  '476671',
  '476672',
  '476675',
  '476676',
  '476677',
  '527551'
];

export const SmartlookEvents = {
  LandingPage: 'landing_page',
  QuotationPage: 'quote_page',
  GetQuotation: 'get_quote',
  TechnicalError: 'technical_error',
  UnderwritePage: 'underwrite_page',
  UnderwriteYes: 'underwrite_yes',
  UnderwriteNo: 'underwrite_no',
  ContactMeDeclined: 'contact_me_declined',
  ApplicationPage: 'application_page',
  ApplicationSubmit: 'application_submit',
  SummaryPage: 'summary_page',
  CheckoutPage: 'checkout_page',
  PaymentStart: 'payment_start',
  PaymentSuccess: 'payment_success',
  PaymentFailure: 'payment_failure'
};

export const DiscountType = {
  Fixed: 'Fixed',
  Percentage: 'Percentage'
};

export const GA_DATA = {
  PRODUCT_CARD: {
    ET2: 'ET2 product card',
    EC2: 'EC2 product card'
  },
  APPLY_BUTTON: {
    ET2: 'Apply ET2',
    EC2: 'Apply EC2'
  },
  PRODUCT_AFFILIATION: 'takaful'
};

export const EventLog = {
  applicationStart: 'applicationStart',
  underwritingEntry: 'underwritingEntry',
  displayPriceChange: 'displayPriceChange',
  acceptPriceChange: 'acceptPriceChange',
  displayLeadForm: 'displayLeadForm',
  leadSubmitted: 'leadSubmitted',
  applicationEntry: 'applicationEntry',
  applicationNext: 'applicationNext',
  leadSubmittedApplication: 'leadSubmittedApplication',
  eKYCEntry: 'eKYCEntry',
  eKYCNnext: 'eKYCNnext',
  summaryEntry: 'summaryEntry',
  summaryNext: 'summaryNext',
  declarationEntry: 'declarationEntry',
  declarationNext: 'declarationNext',
  paymentEntry: 'paymentEntry',
  paymentNext: 'paymentNext',
  successEntry: 'successEntry',
  payment: 'payment',
  viewItem: 'view_item',
  navigation: 'navigation',
  addToCart: 'add_to_cart',
  getAQuote: 'button_click',
  getAQuotehealthCondition: 'get_a_quote',
  underwriting: 'underwriting',
  about: 'about',
  uploadDocument: 'upload_document',
  confirmation: 'confirmation',
  declaration: 'declaration',
  addPaymentInfo: 'add_payment_info',
  purchase: 'purchase',
  popup: 'pop-up',
  error: 'error'
};
